import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

/**
 * Article body renderer. The route already emits the single page <h1>,
 * so we downshift markdown headings by one level (# → h2, ## → h3, etc.)
 * to preserve a valid, single-H1 outline for SEO and screen readers.
 */
export function Markdown({ content }: { content: string }) {
  return (
    <div className="prose-article">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          h1: ({ node, ...props }) => <h2 {...props} />,
          h2: ({ node, ...props }) => <h3 {...props} />,
          h3: ({ node, ...props }) => <h4 {...props} />,
          h4: ({ node, ...props }) => <h5 {...props} />,
          h5: ({ node, ...props }) => <h6 {...props} />,
          h6: ({ node, ...props }) => <h6 {...props} />,
          a: ({ node, href, ...props }) => {
            const isExternal = !!href && /^https?:\/\//i.test(href);
            return (
              <a
                href={href}
                {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                {...props}
              />
            );
          },
          img: ({ node, ...props }) => (
            // eslint-disable-next-line jsx-a11y/alt-text
            <img loading="lazy" decoding="async" {...props} />
          ),
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
